import IPImage from './IPImage'

export default IPImage
